import { createFeatureSelector } from '@ngrx/store';

import {
  HideModalReason,
  ModalControlsSaveable,
  ModalControlsSaveableFactory,
} from '®shared/modals';

export const STATE_FEATURE_DELETE_LIST = 'deleteList';

export interface DeleteListState {
  modalControl: ModalControlsSaveable;
  modalHiddenReason?: HideModalReason;
}

export const DELETE_LIST_INITIAL_STATE: DeleteListState = {
  modalControl: ModalControlsSaveableFactory.hide(),
};

export function getInitialDeleteListState(): DeleteListState {
  return DELETE_LIST_INITIAL_STATE;
}

export const selectDeleteListState = createFeatureSelector<DeleteListState>(
  STATE_FEATURE_DELETE_LIST,
);
